"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6656],{

/***/ 46656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Kc": function() { return /* binding */ asCareGateway; },
  "Gk": function() { return /* binding */ onlineEstimateGateway; },
  "Mb": function() { return /* binding */ orderGateway; }
});

// UNUSED EXPORTS: ClientGetOnlineEstimateDetailGuestGateway, ClientGetOnlineEstimateDetailMemberGateway

// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(1861);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../shared/order/src/index.ts + 12 modules
var src = __webpack_require__(26736);
// EXTERNAL MODULE: ./src/di-container/axios.ts
var axios = __webpack_require__(43856);
;// CONCATENATED MODULE: ./src/di-container/order/gateway/get-estimate-notification-images.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}


/**
 * HSMALL-15407 — 견적 알림톡 참고이미지 조회 래퍼.
 * 현재는 변환 없이 원본 응답을 그대로 리턴한다 (Base Gateway 격리용 매핑 구간).
 * 클라이언트 전용 변환 타입이 필요해지면 이 파일에 정의한다.
 */ var ClientGetEstimateNotificationImagesGateway = /*#__PURE__*/ function() {
    "use strict";
    function ClientGetEstimateNotificationImagesGateway(httpClient) {
        _classCallCheck(this, ClientGetEstimateNotificationImagesGateway);
        this.httpClient = httpClient;
    }
    var _proto = ClientGetEstimateNotificationImagesGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return new src/* GetEstimateNotificationImagesGateway */.UK(_this.httpClient).exec(req);
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return ClientGetEstimateNotificationImagesGateway;
}();

;// CONCATENATED MODULE: ./src/di-container/order/gateway/get-estimate-material-notices.ts
function get_estimate_material_notices_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function get_estimate_material_notices_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                get_estimate_material_notices_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                get_estimate_material_notices_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function get_estimate_material_notices_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}


/**
 * SALES-14036 — 소재고지 알림톡 링크 고지내역 조회 래퍼.
 * 현재는 변환 없이 원본 응답을 그대로 리턴한다 (Base Gateway 격리용 매핑 구간).
 * 클라이언트 전용 변환 타입이 필요해지면 이 파일에 정의한다.
 */ var ClientGetEstimateMaterialNoticesGateway = /*#__PURE__*/ function() {
    "use strict";
    function ClientGetEstimateMaterialNoticesGateway(httpClient) {
        get_estimate_material_notices_classCallCheck(this, ClientGetEstimateMaterialNoticesGateway);
        this.httpClient = httpClient;
    }
    var _proto = ClientGetEstimateMaterialNoticesGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return get_estimate_material_notices_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return new src/* GetEstimateMaterialNoticesGateway */.FT(_this.httpClient).exec(req);
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return ClientGetEstimateMaterialNoticesGateway;
}();

;// CONCATENATED MODULE: ./src/di-container/order/gateway/as-care.ts
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function as_care_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function as_care_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                as_care_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                as_care_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function as_care_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}


/**
 * 한샘 AS케어+ Client Gateway — API 응답을 화면 타입으로 옮기는 구간.
 *
 * 화면(`feat-components/My/AsCare`)은 주문번호로 묶은 `AsCareOrderGroup[]` 을 다룬다.
 * API 는 반대로 **탭(신청가능·가입완료·신청불가)이 최상위**이고 한 주문번호의 상품이
 * 세 탭에 동시에 걸린다. 그 차이를 흡수하는 것이 이 파일의 일이다.
 *
 * 변환 원칙:
 * - 금액·보증구간·환급액은 **서버값을 그대로** 싣는다(화면에서 재계산하지 않는다).
 * - 탭 분류도 서버 그룹을 그대로 `item.tab` 에 싣는다 — 화면의 날짜 재판정과 갈리면
 *   「목록엔 있는데 신청은 반려되는」 상태가 생긴다.
 * - 신청·취소 요청의 식별자(`ordSeq`·`ewRegNo`·`ewPayGrpNo`)를 반드시 함께 싣는다.
 *   화면이 배열 인덱스만 들고 있으면 재조회로 순서가 바뀌는 순간 다른 상품을 신청한다.
 */ /**
 * 화면 상품명 = `상품명 [옵션명]`.
 *
 * 화면은 대괄호 안을 옵션으로 읽어(`splitName`) 서브라인에 따로 표기한다. API 가
 * `gdsNm`·`unitNm` 을 나눠 주므로 화면 관례에 맞춰 다시 합친다.
 */ var composeName = function(gdsNm, unitNm) {
    return unitNm ? "".concat(gdsNm, " [").concat(unitNm, "]") : gdsNm;
};
/** 환급 방법 문구 → 화면 배지 구분. 문구 자체는 `refundMethodNm` 으로 따로 싣는다 */ var toRefundMethod = function(refundMethodNm) {
    return (refundMethodNm === null || refundMethodNm === void 0 ? void 0 : refundMethodNm.includes("카드")) ? "card" : "transfer";
};
var toEligibleItem = function(line) {
    return {
        name: composeName(line.gdsNm, line.unitNm),
        amount: line.totPayAmt,
        qty: line.ordQty,
        deliveryDate: line.deliveryDate,
        status: "eligible",
        tab: "available",
        ordSeq: line.ordSeq,
        gdsNo: line.gdsNo,
        imgUrl: line.imgUrl
    };
};
var toAppliedItem = function(line, ewPayGrpNo) {
    return {
        name: composeName(line.gdsNm, line.unitNm),
        amount: line.totPayAmt,
        qty: line.ordQty,
        deliveryDate: line.deliveryDate,
        status: "applied_done",
        tab: "done",
        /** 가입완료 카드는 신청 회차(= 보험결제그룹) 단위로 나뉜다 */ batchId: ewPayGrpNo,
        ordSeq: line.ordSeq,
        gdsNo: line.gdsNo,
        imgUrl: line.imgUrl,
        ewRegNo: line.ewRegNo,
        premium: line.ewFeeAmt,
        refund: line.expectedEwFeeRefundAmt,
        fwStartDate: line.fwStartDate,
        fwEndDate: line.fwEndDate,
        ewStartDate: line.ewStartDate,
        ewEndDate: line.ewEndDate
    };
};
var toIneligibleItem = function(line) {
    return {
        name: composeName(line.gdsNm, line.unitNm),
        amount: line.totPayAmt,
        qty: line.ordQty,
        deliveryDate: line.deliveryDate,
        status: "ineligible",
        tab: "unavailable",
        ordSeq: line.ordSeq,
        gdsNo: line.gdsNo,
        imgUrl: line.imgUrl,
        ineligibleReasonText: line.ineligibleReason
    };
};
var toCancelledItem = function(line, cancelBatchId, refundMethodNm, cancelReqDate) {
    return {
        name: composeName(line.gdsNm, line.unitNm),
        amount: line.totPayAmt,
        qty: line.ordQty,
        deliveryDate: line.deliveryDate,
        status: "applied_cancelled",
        cancelState: "cancelled",
        cancelBatchId: cancelBatchId,
        refundDate: cancelReqDate,
        refundMethod: toRefundMethod(refundMethodNm),
        /** 회차 단위 값이다 — 같은 주문의 다른 회차와 환급 방법이 다를 수 있다 */ refundMethodNm: refundMethodNm,
        ordSeq: line.ordSeq,
        gdsNo: line.gdsNo,
        imgUrl: line.imgUrl,
        ewRegNo: line.ewRegNo,
        premium: line.ewFeeAmt,
        /** 취소내역은 접수일 기준 **확정** 환급액이다 */ refund: line.ewFeeRefundAmt
    };
};
/**
 * 주문번호로 상품을 모은다.
 *
 * 세 그룹에 흩어진 같은 주문번호를 한 `AsCareOrderGroup` 으로 합친다 — 화면은 주문
 * 단위로 표를 세우고, 상품별 `status`/`tab` 으로 탭을 가른다. 첫 등장 순서를 유지해
 * BE 가 정한 정렬을 뒤집지 않는다.
 */ var mergeByOrderNo = function(entries) {
    var byOrderNo = new Map();
    /** Map 순회는 ES5 타깃에서 막혀 있어 등장 순서를 따로 들고 있는다 */ var ordered = [];
    entries.forEach(function(param) {
        var ordNo = param.ordNo, saleShopNm = param.saleShopNm, items = param.items;
        var ref;
        var found = byOrderNo.get(ordNo);
        if (found) {
            var _items;
            (_items = found.items).push.apply(_items, _toConsumableArray(items));
            return;
        }
        var ref1;
        var group = {
            orderNo: ordNo,
            store: saleShopNm,
            /**
       * 주문 단위 상태는 **상품 상태의 폴백**일 뿐이다(모든 상품이 자기 `status` 를
       * 들고 있다). 첫 상품 기준으로 채워 두면 `itemStatusOf` 가 어긋나지 않는다.
       */ status: (ref1 = (ref = items[0]) === null || ref === void 0 ? void 0 : ref.status) !== null && ref1 !== void 0 ? ref1 : "eligible",
            items: _toConsumableArray(items)
        };
        byOrderNo.set(ordNo, group);
        ordered.push(group);
    });
    return ordered;
};
var EMPTY_LIST = {
    groups: [],
    counts: {
        available: 0,
        done: 0,
        unavailable: 0
    }
};
var ref, _orderLines, ref1, _orderLines1, ref2, _orderLines2, ref3, ref4, ref5;
var toClientAsCareList = function(list) {
    var ref6, ref7, ref8, ref9, ref10, ref11;
    return {
        groups: mergeByOrderNo(_toConsumableArray(((ref = (ref6 = list.eligible) === null || ref6 === void 0 ? void 0 : ref6.orderList) !== null && ref !== void 0 ? ref : []).map(function(order) {
            return {
                ordNo: order.ordNo,
                saleShopNm: order.saleShopNm,
                items: ((_orderLines = order.orderLines) !== null && _orderLines !== void 0 ? _orderLines : []).map(toEligibleItem)
            };
        })).concat(_toConsumableArray(((ref1 = (ref7 = list.applied) === null || ref7 === void 0 ? void 0 : ref7.orderList) !== null && ref1 !== void 0 ? ref1 : []).map(function(order) {
            return {
                ordNo: order.ordNo,
                saleShopNm: order.saleShopNm,
                items: ((_orderLines1 = order.orderLines) !== null && _orderLines1 !== void 0 ? _orderLines1 : []).map(function(line) {
                    return toAppliedItem(line, order.ewPayGrpNo);
                })
            };
        })), _toConsumableArray(((ref2 = (ref8 = list.ineligible) === null || ref8 === void 0 ? void 0 : ref8.orderList) !== null && ref2 !== void 0 ? ref2 : []).map(function(order) {
            return {
                ordNo: order.ordNo,
                saleShopNm: order.saleShopNm,
                items: ((_orderLines2 = order.orderLines) !== null && _orderLines2 !== void 0 ? _orderLines2 : []).map(toIneligibleItem)
            };
        })))),
        counts: {
            available: (ref3 = (ref9 = list.eligible) === null || ref9 === void 0 ? void 0 : ref9.orderLineCount) !== null && ref3 !== void 0 ? ref3 : 0,
            done: (ref4 = (ref10 = list.applied) === null || ref10 === void 0 ? void 0 : ref10.orderLineCount) !== null && ref4 !== void 0 ? ref4 : 0,
            unavailable: (ref5 = (ref11 = list.ineligible) === null || ref11 === void 0 ? void 0 : ref11.orderLineCount) !== null && ref5 !== void 0 ? ref5 : 0
        }
    };
};
/**
 * 보험신청/내역 조회 (SC-02).
 * 실패 시 빈 목록으로 떨어진다 — 화면은 「대상 없음」 문구를 그대로 쓴다.
 */ var ClientGetAsCareListGateway = /*#__PURE__*/ function() {
    "use strict";
    function ClientGetAsCareListGateway(httpClient) {
        as_care_classCallCheck(this, ClientGetAsCareListGateway);
        this.httpClient = httpClient;
    }
    var _proto = ClientGetAsCareListGateway.prototype;
    _proto.exec = function exec() {
        var _this = this;
        return as_care_asyncToGenerator(runtime_default().mark(function _callee() {
            var apiResponse;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return new src/* GetAsCareListGateway */.F9(_this.httpClient).exec();
                    case 2:
                        apiResponse = _ctx.sent;
                        if (!(apiResponse.code !== 200 || !apiResponse.data)) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", _objectSpreadProps(_objectSpread({}, apiResponse), {
                            data: EMPTY_LIST
                        }));
                    case 5:
                        return _ctx.abrupt("return", _objectSpreadProps(_objectSpread({}, apiResponse), {
                            data: toClientAsCareList(apiResponse.data)
                        }));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return ClientGetAsCareListGateway;
}();
/**
 * 취소 회차 하나 → 카드 하나.
 *
 * 상품 순서·금액·환급 방법·접수일 모두 그 회차의 서버값을 그대로 싣는다. 환급 방법과
 * 접수일은 **주문이 아니라 회차에 붙는 값**이라(정책서 9-5절) 주문 단위로 들고 있으면
 * 다른 회차의 값을 표기하게 된다.
 */ var toCancelCard = function(order, cancelSeq) {
    var _orderLines;
    var items = ((_orderLines = order.orderLines) !== null && _orderLines !== void 0 ? _orderLines : []).map(function(line) {
        return toCancelledItem(line, order.ewPayGrpNo, order.refundMethodNm, order.cancelReqDate);
    });
    var refundMethod = toRefundMethod(order.refundMethodNm);
    /** 카드가 곧 회차라 원본 주문에도 이 회차의 상품만 담는다 */ var source = {
        orderNo: order.ordNo,
        store: order.saleShopNm,
        status: "applied_cancelled",
        items: items,
        refundMethod: refundMethod,
        refundMethodNm: order.refundMethodNm,
        refundDate: order.cancelReqDate
    };
    return {
        orderNo: order.ordNo,
        store: order.saleShopNm,
        status: "applied_cancelled",
        rows: items.map(function(item, index) {
            return {
                item: item,
                index: index
            };
        }),
        cancelBatchId: order.ewPayGrpNo,
        cancelSeq: cancelSeq,
        refundMethod: refundMethod,
        refundDate: order.cancelReqDate,
        source: source
    };
};
var _cancelled, _orderLineCount;
var toClientAsCareCancelList = function(list) {
    return {
        cards: ((_cancelled = list.cancelled) !== null && _cancelled !== void 0 ? _cancelled : []).map(toCancelCard),
        count: (_orderLineCount = list.orderLineCount) !== null && _orderLineCount !== void 0 ? _orderLineCount : 0
    };
};
/** 보험취소/내역 조회 (SC-08) */ var ClientGetAsCareCancelListGateway = /*#__PURE__*/ function() {
    "use strict";
    function ClientGetAsCareCancelListGateway(httpClient) {
        as_care_classCallCheck(this, ClientGetAsCareCancelListGateway);
        this.httpClient = httpClient;
    }
    var _proto = ClientGetAsCareCancelListGateway.prototype;
    _proto.exec = function exec() {
        var _this = this;
        return as_care_asyncToGenerator(runtime_default().mark(function _callee() {
            var apiResponse;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return new src/* GetAsCareCancelListGateway */.gU(_this.httpClient).exec();
                    case 2:
                        apiResponse = _ctx.sent;
                        if (!(apiResponse.code !== 200 || !apiResponse.data)) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", _objectSpreadProps(_objectSpread({}, apiResponse), {
                            data: {
                                cards: [],
                                count: 0
                            }
                        }));
                    case 5:
                        return _ctx.abrupt("return", _objectSpreadProps(_objectSpread({}, apiResponse), {
                            data: toClientAsCareCancelList(apiResponse.data)
                        }));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return ClientGetAsCareCancelListGateway;
}();
var _orderLines3, ref6, ref7;
var toClientAsCareApplySheet = function(sheet) {
    var ref, ref1;
    return {
        orderNo: sheet.ordNo,
        store: sheet.saleShopNm,
        orderLineCount: sheet.orderLineCount,
        totOrdPayAmt: sheet.totOrdPayAmt,
        totEwFeeAmt: sheet.totEwFeeAmt,
        payCouponApplied: sheet.payCouponAppliedYn,
        items: ((_orderLines3 = sheet.orderLines) !== null && _orderLines3 !== void 0 ? _orderLines3 : []).map(function(line) {
            return {
                name: composeName(line.gdsNm, line.unitNm),
                amount: line.totPayAmt,
                qty: line.ordQty,
                deliveryDate: line.deliveryDate,
                status: "eligible",
                tab: "available",
                ordSeq: line.ordSeq,
                gdsNo: line.gdsNo,
                premium: line.ewFeeAmt,
                fwStartDate: line.fwStartDate,
                fwEndDate: line.fwEndDate,
                ewStartDate: line.ewStartDate,
                ewEndDate: line.ewEndDate,
                normalSalePrc: line.normalSalePrc,
                dcAmt: line.dcAmt,
                cponAmt: line.cponAmt,
                ewFeeRate: line.ewFeeRate
            };
        }),
        contractor: {
            name: (ref6 = (ref = sheet.contractor) === null || ref === void 0 ? void 0 : ref.orderNm) !== null && ref6 !== void 0 ? ref6 : "",
            phone: (ref7 = (ref1 = sheet.contractor) === null || ref1 === void 0 ? void 0 : ref1.orderMobileNo) !== null && ref7 !== void 0 ? ref7 : ""
        }
    };
};
/** 보험신청서 조회 (SC-03) */ var ClientGetAsCareApplySheetGateway = /*#__PURE__*/ function() {
    "use strict";
    function ClientGetAsCareApplySheetGateway(httpClient) {
        as_care_classCallCheck(this, ClientGetAsCareApplySheetGateway);
        this.httpClient = httpClient;
    }
    var _proto = ClientGetAsCareApplySheetGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return as_care_asyncToGenerator(runtime_default().mark(function _callee() {
            var apiResponse;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return new src/* GetAsCareApplySheetGateway */.yc(_this.httpClient).exec(req);
                    case 2:
                        apiResponse = _ctx.sent;
                        if (!(apiResponse.code !== 200 || !apiResponse.data)) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", _objectSpreadProps(_objectSpread({}, apiResponse), {
                            data: undefined
                        }));
                    case 5:
                        return _ctx.abrupt("return", _objectSpreadProps(_objectSpread({}, apiResponse), {
                            data: toClientAsCareApplySheet(apiResponse.data)
                        }));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return ClientGetAsCareApplySheetGateway;
}();
/**
 * 보험료 결제요청 파라미터 조회 (SC-04 Step 2).
 *
 * 변환하지 않는다 — `payParams` 는 `P_CHKFAKE` 로 봉인된 묶음이라 값을 하나라도
 * 손대면 위변조로 판정된다. 래퍼는 Base Gateway 격리 목적으로만 둔다.
 */ var ClientGetAsCarePayRequestGateway = /*#__PURE__*/ function() {
    "use strict";
    function ClientGetAsCarePayRequestGateway(httpClient) {
        as_care_classCallCheck(this, ClientGetAsCarePayRequestGateway);
        this.httpClient = httpClient;
    }
    var _proto = ClientGetAsCarePayRequestGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return as_care_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return new src/* GetAsCarePayRequestGateway */.f8(_this.httpClient).exec(req);
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return ClientGetAsCarePayRequestGateway;
}();
var _orderLines4;
var toClientAsCareApplyComplete = function(complete) {
    return {
        ewPayGrpNo: complete.ewPayGrpNo,
        orderNo: complete.ordNo,
        store: complete.saleShopNm,
        totOrdPayAmt: complete.totOrdPayAmt,
        payMethodNm: complete.payMethodNm,
        totEwFeeAmt: complete.totEwFeeAmt,
        items: ((_orderLines4 = complete.orderLines) !== null && _orderLines4 !== void 0 ? _orderLines4 : []).map(function(line) {
            return toAppliedItem(line, complete.ewPayGrpNo);
        })
    };
};
/** 보험신청 확정 (SC-05) — PG 인증결과를 넘기면 서버가 승인까지 처리한다 */ var ClientCompleteAsCareApplyGateway = /*#__PURE__*/ function() {
    "use strict";
    function ClientCompleteAsCareApplyGateway(httpClient) {
        as_care_classCallCheck(this, ClientCompleteAsCareApplyGateway);
        this.httpClient = httpClient;
    }
    var _proto = ClientCompleteAsCareApplyGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return as_care_asyncToGenerator(runtime_default().mark(function _callee() {
            var apiResponse;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return new src/* CompleteAsCareApplyGateway */.Yz(_this.httpClient).exec(req);
                    case 2:
                        apiResponse = _ctx.sent;
                        if (!(apiResponse.code !== 200 || !apiResponse.data)) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", _objectSpreadProps(_objectSpread({}, apiResponse), {
                            data: undefined
                        }));
                    case 5:
                        return _ctx.abrupt("return", _objectSpreadProps(_objectSpread({}, apiResponse), {
                            data: toClientAsCareApplyComplete(apiResponse.data)
                        }));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return ClientCompleteAsCareApplyGateway;
}();
var _orderLines5;
var toClientAsCareCancelReceipt = function(receipt) {
    return {
        ewPayGrpNo: receipt.ewPayGrpNo,
        orderNo: receipt.ordNo,
        store: receipt.saleShopNm,
        totEwFeeAmt: receipt.totEwFeeAmt,
        cancelReqDate: receipt.cancelReqDate,
        totEwFeeRefundAmt: receipt.totEwFeeRefundAmt,
        items: ((_orderLines5 = receipt.orderLines) !== null && _orderLines5 !== void 0 ? _orderLines5 : []).map(function(line) {
            return toCancelledItem(line, receipt.ewPayGrpNo, "", receipt.cancelReqDate);
        })
    };
};
/** 보험취소 접수 (SC-07) */ var ClientCancelAsCareGateway = /*#__PURE__*/ function() {
    "use strict";
    function ClientCancelAsCareGateway(httpClient) {
        as_care_classCallCheck(this, ClientCancelAsCareGateway);
        this.httpClient = httpClient;
    }
    var _proto = ClientCancelAsCareGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return as_care_asyncToGenerator(runtime_default().mark(function _callee() {
            var apiResponse;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return new src/* CancelAsCareGateway */.gl(_this.httpClient).exec(req);
                    case 2:
                        apiResponse = _ctx.sent;
                        if (!(apiResponse.code !== 200 || !apiResponse.data)) {
                            _ctx.next = 5;
                            break;
                        }
                        return _ctx.abrupt("return", _objectSpreadProps(_objectSpread({}, apiResponse), {
                            data: undefined
                        }));
                    case 5:
                        return _ctx.abrupt("return", _objectSpreadProps(_objectSpread({}, apiResponse), {
                            data: toClientAsCareCancelReceipt(apiResponse.data)
                        }));
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return ClientCancelAsCareGateway;
}();

;// CONCATENATED MODULE: ./src/di-container/order/gateway/client.ts
function client_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function client_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                client_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                client_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function client_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function client_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function client_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            client_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function client_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function client_objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        client_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






// version에 따라 결제할인 정규화: v2=payCoupons(복수) / v1=payCoupon(단수)→0·1개.
// 0개 판별은 orderBenefit.applyPayCouponCount로 (payCoupon 형태 무관 안전).
var toPaymentDiscounts = function(detail) {
    if (detail.version === 2) {
        var _payCoupons;
        return ((_payCoupons = detail.payCoupons) !== null && _payCoupons !== void 0 ? _payCoupons : []).map(function(pc) {
            return {
                payCouponStep: pc.payCouponStep,
                promoNm: pc.appliedCoupon.promoNm,
                totalApplyAmt: pc.appliedCoupon.totalApplyAmt
            };
        });
    }
    var payCoupon = detail.payCoupon, orderBenefit = detail.orderBenefit;
    var ref;
    var hasPayCoupon = ((ref = orderBenefit === null || orderBenefit === void 0 ? void 0 : orderBenefit.applyPayCouponCount) !== null && ref !== void 0 ? ref : 0) > 0 && !!(payCoupon === null || payCoupon === void 0 ? void 0 : payCoupon.promoNo);
    var ref1, ref2;
    return hasPayCoupon ? [
        {
            payCouponStep: 1,
            promoNm: (ref1 = payCoupon === null || payCoupon === void 0 ? void 0 : payCoupon.promoNm) !== null && ref1 !== void 0 ? ref1 : "",
            totalApplyAmt: (ref2 = payCoupon === null || payCoupon === void 0 ? void 0 : payCoupon.totalApplyAmt) !== null && ref2 !== void 0 ? ref2 : 0
        }, 
    ] : [];
};
var withPaymentDiscounts = function(res) {
    return client_objectSpreadProps(client_objectSpread({}, res), {
        data: res.data ? client_objectSpreadProps(client_objectSpread({}, res.data), {
            paymentDiscounts: toPaymentDiscounts(res.data)
        }) : undefined
    });
};
var ClientGetOnlineEstimateDetailMemberGateway = /*#__PURE__*/ function() {
    "use strict";
    function ClientGetOnlineEstimateDetailMemberGateway(httpClient) {
        client_classCallCheck(this, ClientGetOnlineEstimateDetailMemberGateway);
        this.httpClient = httpClient;
    }
    var _proto = ClientGetOnlineEstimateDetailMemberGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return client_asyncToGenerator(runtime_default().mark(function _callee() {
            var res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return new src/* GetOnlineEstimateDetailMemberGateway */.OW(_this.httpClient).exec(req);
                    case 2:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", withPaymentDiscounts(res));
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return ClientGetOnlineEstimateDetailMemberGateway;
}();
var ClientGetOnlineEstimateDetailGuestGateway = /*#__PURE__*/ function() {
    "use strict";
    function ClientGetOnlineEstimateDetailGuestGateway(httpClient) {
        client_classCallCheck(this, ClientGetOnlineEstimateDetailGuestGateway);
        this.httpClient = httpClient;
    }
    var _proto = ClientGetOnlineEstimateDetailGuestGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return client_asyncToGenerator(runtime_default().mark(function _callee() {
            var res;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return new src/* GetOnlineEstimateDetailGuestGateway */.OE(_this.httpClient).exec(req);
                    case 2:
                        res = _ctx.sent;
                        return _ctx.abrupt("return", withPaymentDiscounts(res));
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return ClientGetOnlineEstimateDetailGuestGateway;
}();
var orderGateway = function() {
    return {
        addCartGoods: new src/* AddCartGoodsGateway */.R3(axios/* axios */.o),
        buyDirectGoods: new src/* BuyDirectGoodsGateway */.dY(axios/* axios */.o)
    };
};
// OFFBEN-83 — 목록/상세 v3(version 인지)로 전환. 인증/주문상태는 v1 유지.
var onlineEstimateGateway = function() {
    return {
        member: new src/* GetOnlineEstimateMemberGateway */.wV(axios/* axios */.o),
        guest: new src/* GetOnlineEstimateGuestGateway */.tT(axios/* axios */.o),
        memberDetail: new ClientGetOnlineEstimateDetailMemberGateway(axios/* axios */.o),
        guestDetail: new ClientGetOnlineEstimateDetailGuestGateway(axios/* axios */.o),
        certification: new src/* CreateEstimateCertificationGateway */.WO(axios/* axios */.o),
        certificationConfirm: new src/* CreateEstimateCertificationConfirmGateway */.PN(axios/* axios */.o),
        updateStatus: new src/* UpdateOnlineEstimateOrderStatusGateway */.g2(axios/* axios */.o),
        // HSMALL-15407 — 견적 알림톡 참고이미지 조회 (비로그인 토큰 기반)
        notificationImages: new ClientGetEstimateNotificationImagesGateway(axios/* axios */.o),
        // SALES-14036 — 소재고지 알림톡 고지내역 조회 (비로그인 토큰 기반)
        materialNotices: new ClientGetEstimateMaterialNoticesGateway(axios/* axios */.o)
    };
};
/**
 * 한샘 AS케어+ (연장보증보험) — SC-02 · SC-03 · SC-04 · SC-05 · SC-07 · SC-08.
 * 대상 회원은 토큰으로 특정되므로 목록 조회에는 파라미터가 없다.
 */ var asCareGateway = function() {
    return {
        /** SC-02 보험신청/내역 */ list: new ClientGetAsCareListGateway(axios/* axios */.o),
        /** SC-03 보험신청서 */ applySheet: new ClientGetAsCareApplySheetGateway(axios/* axios */.o),
        /** SC-04 Step 2 결제요청 파라미터 */ payRequest: new ClientGetAsCarePayRequestGateway(axios/* axios */.o),
        /** SC-05 신청 확정 (PG 인증결과 중계) */ applyComplete: new ClientCompleteAsCareApplyGateway(axios/* axios */.o),
        /** SC-07 취소 접수 */ cancel: new ClientCancelAsCareGateway(axios/* axios */.o),
        /** SC-08 보험취소/내역 */ cancelList: new ClientGetAsCareCancelListGateway(axios/* axios */.o)
    };
};


/***/ }),

/***/ 26736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "fv": function() { return /* reexport */ AS_CARE_CODE; },
  "R3": function() { return /* reexport */ AddCartGoodsGateway; },
  "Iv": function() { return /* reexport */ BL_SINGLE_CODE; },
  "dY": function() { return /* reexport */ BuyDirectGoodsGateway; },
  "gl": function() { return /* reexport */ CancelAsCareGateway; },
  "Yz": function() { return /* reexport */ CompleteAsCareApplyGateway; },
  "PN": function() { return /* reexport */ CreateEstimateCertificationConfirmGateway; },
  "WO": function() { return /* reexport */ CreateEstimateCertificationGateway; },
  "VQ": function() { return /* reexport */ FAB_ACCESSORY; },
  "Ll": function() { return /* reexport */ FAB_BLIND; },
  "U7": function() { return /* reexport */ FAB_CURTAIN; },
  "SH": function() { return /* reexport */ FAB_RUG; },
  "W2": function() { return /* reexport */ FAB_STANDARD; },
  "yc": function() { return /* reexport */ GetAsCareApplySheetGateway; },
  "gU": function() { return /* reexport */ GetAsCareCancelListGateway; },
  "F9": function() { return /* reexport */ GetAsCareListGateway; },
  "f8": function() { return /* reexport */ GetAsCarePayRequestGateway; },
  "FT": function() { return /* reexport */ GetEstimateMaterialNoticesGateway; },
  "UK": function() { return /* reexport */ GetEstimateNotificationImagesGateway; },
  "OE": function() { return /* reexport */ GetOnlineEstimateDetailGuestGateway; },
  "OW": function() { return /* reexport */ GetOnlineEstimateDetailMemberGateway; },
  "tT": function() { return /* reexport */ GetOnlineEstimateGuestGateway; },
  "wV": function() { return /* reexport */ GetOnlineEstimateMemberGateway; },
  "g2": function() { return /* reexport */ UpdateOnlineEstimateOrderStatusGateway; },
  "B": function() { return /* reexport */ resolveOrderNoticeConfirm; }
});

// UNUSED EXPORTS: GetCartCounterGateway, ORDER_NOTICE_TRIP_FEE_DUPLICATE_TYPE, ORDER_NOTICE_TRIP_FEE_MISSING_TYPE, hello

;// CONCATENATED MODULE: ../../shared/order/src/utils/order-notice.ts
/** 출장비 누락 안내 유형 (BuyResponse.Notice.type) */ var ORDER_NOTICE_TRIP_FEE_MISSING_TYPE = "VISIT_FEE_REQUIRED";
/** 출장비 초과 안내 유형 (BuyResponse.Notice.type) */ var ORDER_NOTICE_TRIP_FEE_DUPLICATE_TYPE = "VISIT_FEE_DUPLICATE";
/**
 * 주문 응답의 notice 를 컨펌창 표시 정보로 해소한다. (HSMALL-16745)
 *
 * BE 계약: 응답 code 는 정상과 동일하게 200 이고, 체크룰에 걸린 경우에만
 * data.notice = { type, message } 가 실려온다. 판정과 문구는 BE 가 소유하므로
 * (message 에 줄바꿈까지 포함) 프론트는 notice 에 없는 버튼 라벨만 결정한다.
 * → 출장비 누락(VISIT_FEE_REQUIRED)만 옵션 드로워 자동 추가가 가능해 `출장비 추가` 를
 *   제공하고, 그 외 유형(초과 VISIT_FEE_DUPLICATE 포함)은 `수정하기` 로 드로워 수정을 안내한다.
 *
 * @param canAddTripFee 출장비 자동 추가가 가능한 경로인지 (패키지 주문은 불가)
 */ var resolveOrderNoticeConfirm = function(param) {
    var notice = param.notice, _canAddTripFee = param.canAddTripFee, canAddTripFee = _canAddTripFee === void 0 ? true : _canAddTripFee;
    if (!(notice === null || notice === void 0 ? void 0 : notice.message)) return undefined;
    var isAddTripFee = notice.type === ORDER_NOTICE_TRIP_FEE_MISSING_TYPE && canAddTripFee;
    return {
        content: notice.message,
        confirmText: "이대로 구매",
        cancelText: isAddTripFee ? "출장비 추가" : "수정하기",
        isAddTripFee: isAddTripFee
    };
};

;// CONCATENATED MODULE: ../../shared/order/src/utils/index.ts
var hello = function() {
    return "hello";
};


;// CONCATENATED MODULE: ../../shared/order/src/model/dto/as-care.ts
/**
 * 한샘 AS케어+ (연장보증보험) API DTO — order-service `한샘몰 AS케어+`.
 *
 * ⚠️ BE 는 현재 **목업 응답** 단계다(swagger 전체 오퍼레이션에 명시). 스펙은 확정이지만
 * 값은 고정값이 섞여 있어(예: `pay-request` 의 `P_AMT` 는 테스트 결제용 1000원 고정)
 * 금액 대사로 화면을 검증하지 않는다.
 */ /**
 * AS케어+ 업무 응답 코드.
 *
 * swagger 는 이 값들을 HTTP status 자리에 선언하지만, 이 레포의 다른 order-service
 * API 와 마찬가지로 판정은 **응답 본문의 `code`** 로 한다 — HTTP 는 200 으로 오고
 * 업무 실패는 `code` 로 구분한다.
 *
 * ⚠️ 코드 체계가 `7xx` → `9xx` 로 **전면 개편**됐다(order-service swagger 기준).
 * 이전 스펙의 `721`(신청기간 경과)·`722`·`723` 은 더 이상 내려오지 않는다 —
 * 취소 관련 두 건은 `904`·`905` 로 옮겨왔고, `721` 은 대응 코드가 없어졌다.
 *
 * 화면은 이 상수로 **개별 분기**하지 않는다. 「200 이 아니면 서버 `message` 를 얼럿」이
 * 기본이고, 문구는 전부 BE 응답에 실려 온다 — 프론트가 사본을 들고 있으면 두 곳이
 * 갈린다. 여기 이름을 두는 것은 **얼럿이 아닌 처리**가 필요한 코드
 * (`905` 는 전용 다이얼로그, `907` 은 전용 화면, `903` 은 성공 취급)를 가리키기
 * 위해서다.
 */ var AS_CARE_CODE = {
    /** 정상 */ OK: 200,
    /** 결제 인증에 실패했습니다. 다시 시도해 주세요 */ PAY_AUTH_FAILED: 900,
    /** 결제 승인에 실패했습니다. 다시 시도해 주세요 */ PAY_APPROVE_FAILED: 901,
    /** 결제 금액이 일치하지 않습니다. 고객센터로 문의해 주세요 (1588-0900) */ PAY_AMOUNT_MISMATCH: 902,
    /** 이미 처리된 결제입니다 — 재전송·중복 확정으로 들어온다(BE 멱등 응답) */ PAY_ALREADY_DONE: 903,
    /** 보험종료일에는 보험취소가 불가능합니다 (이전 `722`) */ CANCEL_ON_END_DATE: 904,
    /** 취소가 불가능합니다 고객센터로 문의해 주세요 (1588-0900) (이전 `723`) */ CANCEL_UNAVAILABLE: 905,
    /** 이미 처리 중인 취소 요청입니다. 잠시 후 다시 확인해 주세요 */ CANCEL_IN_PROGRESS: 906,
    /**
   * 주문 정보를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.
   *
   * 목록 화면(SC-02 · SC-08)에서는 **얼럿이 아니라 전용 화면**으로 낸다 — 목록 자체가
   * 비어 있는 상태라 얼럿을 닫으면 「대상 없음」과 구분되지 않는다.
   */ ORDER_LOOKUP_FAILED: 907,
    /** 주문 정보가 변경되어 신청할 수 없습니다. 목록에서 다시 확인해 주세요 */ ORDER_CHANGED: 908
};

;// CONCATENATED MODULE: ../../shared/order/src/model/dto/index.ts


;// CONCATENATED MODULE: ../../shared/order/src/model/vo/index.ts

// 패브릭 상품 종류 constant추가
var FAB_CURTAIN = "CT"; // 커튼
var FAB_BLIND = "BL"; // 블라인드
var FAB_RUG = "RG"; // 러그
var FAB_STANDARD = "STD"; // 규격상품
var FAB_ACCESSORY = "ACC"; // ACC/부자재
var BL_SINGLE_CODE = "FBW_S"; // 블라인드 - 단창 코드

;// CONCATENATED MODULE: ../../shared/order/src/model/index.ts



// EXTERNAL MODULE: ../../.yarn/__virtual__/next-virtual-769137b2ab/0/cache/next-npm-12.2.3-07d597c2b7-b13b42fbb3.zip/node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(1861);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ../../shared/order/src/adapter/gateway/as-care.ts
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

/**
 * 한샘 AS케어+ (연장보증보험) Base Gateway — order-service `한샘몰 AS케어+`.
 *
 * API 호출만 담당한다. 화면용 모양으로 바꾸는 일은 di-container 래퍼가 맡는다.
 */ var BASE_URL = "".concat("https://gateway.hanssem.com", "/hanssem/order-service/api/mall/v1/as-care");
/**
 * 보험신청/내역 조회 (SC-02).
 * 신청가능·가입완료·신청불가 3개 탭을 한 번에 받는다 — 페이지네이션이 없다.
 */ var GetAsCareListGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetAsCareListGateway(httpClient) {
        _classCallCheck(this, GetAsCareListGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetAsCareListGateway.prototype;
    _proto.exec = function exec() {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: BASE_URL
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetAsCareListGateway;
}();
/** 보험신청서 조회 (SC-03) */ var GetAsCareApplySheetGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetAsCareApplySheetGateway(httpClient) {
        _classCallCheck(this, GetAsCareApplySheetGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetAsCareApplySheetGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "POST",
                            url: "".concat(BASE_URL, "/apply-sheet"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetAsCareApplySheetGateway;
}();
/**
 * 보험료 결제요청 파라미터 조회 (SC-04 Step 2).
 * 서버가 PG 를 호출하지는 않는다 — 결제창에 넘길 파라미터를 서명해서 내려줄 뿐이다.
 */ var GetAsCarePayRequestGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetAsCarePayRequestGateway(httpClient) {
        _classCallCheck(this, GetAsCarePayRequestGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetAsCarePayRequestGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "POST",
                            url: "".concat(BASE_URL, "/pay-request"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetAsCarePayRequestGateway;
}();
/**
 * 보험신청 확정 (SC-05).
 * PG 인증결과를 넘기면 서버가 승인까지 처리하고 가입을 확정한다.
 */ var CompleteAsCareApplyGateway = /*#__PURE__*/ function() {
    "use strict";
    function CompleteAsCareApplyGateway(httpClient) {
        _classCallCheck(this, CompleteAsCareApplyGateway);
        this.httpClient = httpClient;
    }
    var _proto = CompleteAsCareApplyGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "POST",
                            url: "".concat(BASE_URL, "/apply-complete"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return CompleteAsCareApplyGateway;
}();
/**
 * 보험취소 접수 (SC-07).
 * PG 취소가 실패하면 접수되지 않는다 — 고객이 재시도할 수 있어야 하기 때문이다.
 */ var CancelAsCareGateway = /*#__PURE__*/ function() {
    "use strict";
    function CancelAsCareGateway(httpClient) {
        _classCallCheck(this, CancelAsCareGateway);
        this.httpClient = httpClient;
    }
    var _proto = CancelAsCareGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "POST",
                            url: "".concat(BASE_URL, "/cancels"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return CancelAsCareGateway;
}();
/** 보험취소/내역 조회 (SC-08) */ var GetAsCareCancelListGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetAsCareCancelListGateway(httpClient) {
        _classCallCheck(this, GetAsCareCancelListGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetAsCareCancelListGateway.prototype;
    _proto.exec = function exec() {
        var _this = this;
        return _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat(BASE_URL, "/cancels")
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetAsCareCancelListGateway;
}();

;// CONCATENATED MODULE: ../../shared/order/src/adapter/gateway/goods.ts
function goods_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function goods_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                goods_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                goods_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function goods_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var AddCartGoodsGateway = /*#__PURE__*/ function() {
    "use strict";
    function AddCartGoodsGateway(httpClient) {
        goods_classCallCheck(this, AddCartGoodsGateway);
        this.httpClient = httpClient;
    }
    var _proto = AddCartGoodsGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return goods_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "POST",
                            url: "".concat("https://gateway.hanssem.com", "/hanssem/order-service/api/mall/v1/orders/cart"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return AddCartGoodsGateway;
}();
var BuyDirectGoodsGateway = /*#__PURE__*/ function() {
    "use strict";
    function BuyDirectGoodsGateway(httpClient) {
        goods_classCallCheck(this, BuyDirectGoodsGateway);
        this.httpClient = httpClient;
    }
    var _proto = BuyDirectGoodsGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return goods_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "POST",
                            url: "".concat("https://gateway.hanssem.com", "/hanssem/order-service/api/mall/v1/orders/direct-buy"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return BuyDirectGoodsGateway;
}();

// EXTERNAL MODULE: ../../.yarn/cache/lodash-npm-4.17.21-6382451519-eb835a2e51.zip/node_modules/lodash/lodash.js
var lodash = __webpack_require__(35735);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
;// CONCATENATED MODULE: ../../shared/order/src/adapter/gateway/online-estimate.ts
function online_estimate_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function online_estimate_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                online_estimate_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                online_estimate_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function online_estimate_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}


var online_estimate_BASE_URL = "".concat("https://gateway.hanssem.com", "/hanssem/order-service/api/mall/v1/estimates");
// OFFBEN-83 — 목록/상세 v3(version 인지) 전용. v1 BASE_URL 은 certification/order-status 공유로 불변.
var BASE_URL_V3 = "".concat("https://gateway.hanssem.com", "/hanssem/order-service/api/mall/v3/estimates");
var CreateEstimateCertificationGateway = /*#__PURE__*/ function() {
    "use strict";
    function CreateEstimateCertificationGateway(httpClient) {
        online_estimate_classCallCheck(this, CreateEstimateCertificationGateway);
        this.httpClient = httpClient;
    }
    var _proto = CreateEstimateCertificationGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return online_estimate_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "POST",
                            url: "".concat(online_estimate_BASE_URL, "/certification"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return CreateEstimateCertificationGateway;
}();
var CreateEstimateCertificationConfirmGateway = /*#__PURE__*/ function() {
    "use strict";
    function CreateEstimateCertificationConfirmGateway(httpClient) {
        online_estimate_classCallCheck(this, CreateEstimateCertificationConfirmGateway);
        this.httpClient = httpClient;
    }
    var _proto = CreateEstimateCertificationConfirmGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return online_estimate_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "POST",
                            url: "".concat(online_estimate_BASE_URL, "/certification/confirm"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return CreateEstimateCertificationConfirmGateway;
}();
var UpdateOnlineEstimateOrderStatusGateway = /*#__PURE__*/ function() {
    "use strict";
    function UpdateOnlineEstimateOrderStatusGateway(httpClient) {
        online_estimate_classCallCheck(this, UpdateOnlineEstimateOrderStatusGateway);
        this.httpClient = httpClient;
    }
    var _proto = UpdateOnlineEstimateOrderStatusGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return online_estimate_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "PUT",
                            url: "".concat(online_estimate_BASE_URL, "/").concat(req.estimateId, "/order-status")
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return UpdateOnlineEstimateOrderStatusGateway;
}();
/**
 * OFFBEN-83 — 온라인견적서 v3(version 인지) 목록/상세 게이트웨이.
 */ var GetOnlineEstimateMemberGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetOnlineEstimateMemberGateway(httpClient) {
        online_estimate_classCallCheck(this, GetOnlineEstimateMemberGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetOnlineEstimateMemberGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return online_estimate_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat(BASE_URL_V3),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetOnlineEstimateMemberGateway;
}();
var GetOnlineEstimateGuestGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetOnlineEstimateGuestGateway(httpClient) {
        online_estimate_classCallCheck(this, GetOnlineEstimateGuestGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetOnlineEstimateGuestGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return online_estimate_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat(BASE_URL_V3, "/guest"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetOnlineEstimateGuestGateway;
}();
var GetOnlineEstimateDetailMemberGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetOnlineEstimateDetailMemberGateway(httpClient) {
        online_estimate_classCallCheck(this, GetOnlineEstimateDetailMemberGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetOnlineEstimateDetailMemberGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return online_estimate_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat(BASE_URL_V3, "/").concat(req.estimateId)
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetOnlineEstimateDetailMemberGateway;
}();
var GetOnlineEstimateDetailGuestGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetOnlineEstimateDetailGuestGateway(httpClient) {
        online_estimate_classCallCheck(this, GetOnlineEstimateDetailGuestGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetOnlineEstimateDetailGuestGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return online_estimate_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat(BASE_URL_V3, "/").concat(req.estimateId, "/guest"),
                            body: lodash_default().omit(req, "estimateId")
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetOnlineEstimateDetailGuestGateway;
}();
/**
 * HSMALL-15407 — 견적 알림톡 내 참고이미지 조회. 비로그인 접근 가능(토큰 기반).
 */ var GetEstimateNotificationImagesGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetEstimateNotificationImagesGateway(httpClient) {
        online_estimate_classCallCheck(this, GetEstimateNotificationImagesGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetEstimateNotificationImagesGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return online_estimate_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat(online_estimate_BASE_URL, "/notification-images"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetEstimateNotificationImagesGateway;
}();
/**
 * SALES-14036 — 소재고지 알림톡 링크 고지내역 조회. 비로그인 접근 가능(토큰 기반).
 * 정렬(발송일시 내림차순)은 BE 가 보장하므로 클라이언트에서 재정렬하지 않는다.
 */ var GetEstimateMaterialNoticesGateway = /*#__PURE__*/ function() {
    "use strict";
    function GetEstimateMaterialNoticesGateway(httpClient) {
        online_estimate_classCallCheck(this, GetEstimateMaterialNoticesGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetEstimateMaterialNoticesGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return online_estimate_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat(online_estimate_BASE_URL, "/material-notices"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetEstimateMaterialNoticesGateway;
}();

;// CONCATENATED MODULE: ../../shared/order/src/adapter/gateway/orders.ts
function orders_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function orders_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                orders_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                orders_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function orders_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}

var GetCartCounterGateway = /*#__PURE__*/ (/* unused pure expression or super */ null && (function() {
    "use strict";
    function GetCartCounterGateway(httpClient) {
        orders_classCallCheck(this, GetCartCounterGateway);
        this.httpClient = httpClient;
    }
    var _proto = GetCartCounterGateway.prototype;
    _proto.exec = function exec(req) {
        var _this = this;
        return orders_asyncToGenerator(regeneratorRuntime.mark(function _callee() {
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return _this.httpClient.request({
                            method: "GET",
                            url: "".concat("https://gateway.hanssem.com", "/hanssem/order-service/api/mall/v1/orders/cart-count"),
                            body: req
                        });
                    case 2:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    };
    return GetCartCounterGateway;
}()));

;// CONCATENATED MODULE: ../../shared/order/src/adapter/gateway/index.ts





;// CONCATENATED MODULE: ../../shared/order/src/adapter/index.ts


;// CONCATENATED MODULE: ../../shared/order/src/index.ts





/***/ })

}]);